import { PropsWithChildren, createContext, useMemo } from "react";

const CheckoutModeContext = createContext({
  preview: false,
});

const CheckoutModeProvider: React.FC<
  PropsWithChildren<{
    preview: boolean;
  }>
> = ({ children, preview }) => {
  const value = useMemo(() => ({ preview }), [preview]);

  return (
    <CheckoutModeContext.Provider value={value}>
      {children}
    </CheckoutModeContext.Provider>
  );
};

export { CheckoutModeContext, CheckoutModeProvider };
